import React from 'react';
import { Box, Button, Flex, Text } from '@neta';
import { DownCaret } from '@components/Caret';
import theme from '@styles/theme';

export default class SelectButton extends React.Component {
  render() {
    const {
      bg,
      border,
      borderRadius,
      getInputProps,
      getToggleButtonProps,
      placeholder,
      selectedItem,
      textStyle,
      width
    } = this.props;

    return (
      <Button.select
        bg={bg}
        {...getInputProps()}
        {...getToggleButtonProps()}
        border={border}
        borderRadius={borderRadius}
        width={width}
        {...theme.textStyles[textStyle]}
        css="overflow: hidden;"
        data-testid="select-button"
      >
        <Flex alignItems="center" justifyContent="space-between">
          <Text noWrap>
            {selectedItem || <Text color="grayscale.stone">{placeholder}</Text>}
          </Text>
          <Box pl={3}>
            <DownCaret size="4px" />
          </Box>
        </Flex>
      </Button.select>
    );
  }
}
